import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DmsService } from '../../dms/dms.service';
import { PageSettingsModel, InfiniteScrollSettingsModel, GridComponent, ResizeService, ReorderService, SortService, GroupService, InfiniteScrollService } from '@syncfusion/ej2-angular-grids';
import { DmsTemplateBreadcrumb, ExplorerItem } from 'src/app/Models/SharePointPracticeModel';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-dms-template-location',
  templateUrl: './dms-template-location.component.html',
  styleUrls: ['./dms-template-location.component.scss'],
  providers: [
    ResizeService,
    ReorderService,
    SortService,
    GroupService,
    InfiniteScrollService
  ],
})
export class DmsTemplateLocationComponent implements OnInit {
  @Input() driveId!: string;
  @Input() driveItemId!: string;
  @Input() isNonSharePoint: boolean = false;
  private _templatedatList: any[] = [];
  @Input()
  set templatedatList(value: any[]) {
    this._templatedatList = value || [];
    if (!this.isNonSharePoint) {
      this.temptemplatedatList = this.withFileIcon(this._templatedatList.filter(item => item.parentId === null));
    }
  }

  get templatedatList(): any[] {
    return this._templatedatList;
  }

  @Output() outputParameter = new EventEmitter<void>();
  @Output() sendFolderLocation = new EventEmitter<any>();
  @Output() templateSelected = new EventEmitter<any>();
  @ViewChild('grid', { static: false })
  public grid!: GridComponent;
  temptemplatedatList: any[] = [];
  folders: any[] = [];
  breadcrumbData: any[] = [];
  groupName: string;
  destinationFolderId: any = null;
  folderlocationObj: {
    locationPath: string;
    locationFolderId: any;
  };
  public pageSettings: Object;
  public options: PageSettingsModel;
  public infiniteOptions: InfiniteScrollSettingsModel;
  public groupOptions: Object;
  public initialPage?: PageSettingsModel;
  templateListData: any[] = [];
  dmsTemplateData: ExplorerItem[] = [];
  currentDmsFolderPath: string = '';
  dmsBreadcrumbs: DmsTemplateBreadcrumb[] = [];
  searchKeyword: string = '';
  constructor(private _dmsService: DmsService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.initialPage = {
      pageSize: 5
    };

    this.infiniteOptions = {
      enableCache: true,
      maxBlocks: 5
    };

    if (this.isNonSharePoint) {
      this.getDmsTemplates();
    }
  }

  emitSelectedFolder(folder: any): void {
    this.sendFolderLocation.emit(folder);
  }

  hidePopupFromChild(): void {
    this.outputParameter.emit();
  }

  closePopUp(): void {
    this.outputParameter.emit();
  }

  handleItemClick(data: any): void {
    if (this.isNonSharePoint) {
      if (data.type === 'Folder') {
        this.openDmsFolder(data);
        return;
      }

      if (data.type === 'File') {
        this.templateSelected.emit(data);
        return;
      }

      return;
    }

    if (data.type === 'Folder') {
      this.folderPath(data.id);
    } else if (data.type === 'File') {
      this.sendFolderLocation.emit(data);
    }
  }

  folderPath(folderId: string): void {
    this.temptemplatedatList = this.withFileIcon(this._templatedatList.filter(item => item.parentId === folderId));
    const clickedFolder = this._templatedatList.find(x => x.id === folderId);
    if (clickedFolder) {

      const existsInTrail = this.breadcrumbData.find(b => b.Id === clickedFolder.id);
      if (!existsInTrail) {

        this.breadcrumbData.push({
          Id: clickedFolder.id,
          FolderName: clickedFolder.name,
          ParentId: clickedFolder.parentId
        });

      } else {
        const index = this.breadcrumbData.findIndex(b => b.Id === folderId);
        this.breadcrumbData = this.breadcrumbData.slice(0, index + 1);
      }
    }
  }

  homeBreadCrumbClicked(): void {
    if (this.isNonSharePoint) {
      this.dmsBreadcrumbs = [];
      this.searchKeyword = '';
      this.loadDmsFolder('');
      return;
    }

    this.breadcrumbData = [];

    if (this.isNonSharePoint) {
      this.temptemplatedatList = [...this._templatedatList];
    } else {
      this.temptemplatedatList = this.withFileIcon(this._templatedatList.filter(item => item.parentId === null));
    }
  }

  openDmsFolder(folder: ExplorerItem): void {
    const folderPath = this.getCleanPath(folder.fullBlobPath || '');

    if (!folderPath) {
      return;
    }

    const isSameParent = this.currentDmsFolderPath === this.getParentPath(folderPath);
    if (!isSameParent) {
      this.buildDmsBreadcrumbsForPath(folderPath);
    } else {
      const folderName = folder.name || this.getFolderName(folder.fullBlobPath || '');
      const existingIndex = this.dmsBreadcrumbs.findIndex(
        item => item.path === folderPath
      );

      if (existingIndex >= 0) {
        this.dmsBreadcrumbs = this.dmsBreadcrumbs.slice(0, existingIndex + 1);
      } else {
        this.dmsBreadcrumbs.push({
          id: folder.id,
          name: folderName,
          path: folderPath
        });
      }
    }

    this.searchKeyword = '';
    this.loadDmsFolder(folderPath);
  }

  buildDmsBreadcrumbsForPath(folderPath: string): void {
    const rootPath = this.getDmsRootFolderPath();
    this.dmsBreadcrumbs = [];
    if (folderPath === rootPath) {
      return;
    }

    const pathSegments = this.getCleanPath(folderPath).split('/');
    const rootSegments = rootPath.split('/');

    let currentPath = '';

    for (let i = rootSegments.length; i < pathSegments.length; i++) {
      currentPath += (currentPath ? '/' : '') + pathSegments[i];
      const fullPath = rootPath + '/' + currentPath;
      const folderItem = this.dmsTemplateData.find(item =>
        item.type === 'Folder' &&
        this.getCleanPath(item.fullBlobPath || '') === fullPath
      );

      this.dmsBreadcrumbs.push({
        id: folderItem?.id ?? null,
        name: folderItem?.name || pathSegments[i],
        path: fullPath
      });
    }
  }

  loadDmsFolder(folderPath: string = ''): void {
    const rootPath = this.getDmsRootFolderPath();
    const targetPath = folderPath || rootPath;

    this.currentDmsFolderPath = targetPath;
    this.temptemplatedatList = this.dmsTemplateData.filter(item => {

      const itemPath = this.getCleanPath(item.fullBlobPath || '');
      if (itemPath === rootPath) {
        return false;
      }

      const itemParentPath = this.getParentPath(itemPath);
      return itemParentPath === targetPath;
    }).map(item => ({
      ...item,
      fileImageUrl: this.getImageForFile(item.name)
    }));
  }

  dmsBreadcrumbClick(breadcrumb: DmsTemplateBreadcrumb, index: number): void {
    this.dmsBreadcrumbs = this.dmsBreadcrumbs.slice(0, index + 1);
    this.searchKeyword = '';
    this.loadDmsFolder(breadcrumb.path);
  }

  getDmsTemplates(): void {
    this._dmsService.getDmsTemplates().subscribe({
      next: (response: any) => {
        if (!response?.isSuccess) {
          return;
        }

        const templates = response.templates || [];
        this.dmsTemplateData = templates.map((item: any) => ({
          id: item.id,
          parentId: null,
          name: item.name || this.getFolderName(item.fullBlobPath || ''),
          nameWithoutExtension: item.nameWithoutExtension,
          type: item.type,
          createdBy: item.uploadedBy || '',
          createdOn: item.blobModifiedUtc || '',
          fullBlobPath: item.fullBlobPath,
          parentPath: item.parentPath,
          leaseStatus: item.leaseStatus,
          isLocked: item.leaseStatus === 'Locked',
          fileImageUrl: item.type === 'Folder'
            ? '../../../assets/img/dms-icons/folder.svg'
            : this.getImageForFile(item.name)
        }));

        this.templateListData = templates.map((item: any) => ({
          ...item,
          TemplateName: item.nameWithoutExtension,
          UploadedOn: item.blobModifiedUtc
        }));


        this.dmsBreadcrumbs = [];
        this.searchKeyword = '';
        this.loadDmsFolder('');
      },
      error: (error) => {
        this.toastr.error(error?.error?.message || 'Error fetching DMS templates');
      }
    });
  }

  getDmsRootFolderPath(): string {
    const rootFolder = this.dmsTemplateData.find(item => {
      if (item.type !== 'Folder') {
        return false;
      }

      const cleanPath = this.getCleanPath(item.fullBlobPath || '');
      const parentPath = this.getParentPath(cleanPath);
      return parentPath === 'Kloud Connect';
    });

    if (rootFolder?.fullBlobPath) {
      return this.getCleanPath(rootFolder.fullBlobPath);
    }

    const paths = this.dmsTemplateData.map(item => {
      const cleanPath = this.getCleanPath(item.fullBlobPath || '');

      if (item.type === 'Folder') {
        return cleanPath;
      }

      return this.getParentPath(cleanPath);
    })
      .filter(path => !!path);

    if (!paths.length) {
      return '';
    }

    return paths.reduce(
      (shortest, current) => {
        return current.split('/').length < shortest.split('/').length ? current : shortest;
      }
    );
  }

  getCleanPath(path: string = ''): string {
    return path.replace(/\/+$/, '');
  }

  getParentPath(fullBlobPath: string = ''): string {
    const cleanPath = this.getCleanPath(fullBlobPath);
    const lastSlashIndex = cleanPath.lastIndexOf('/');

    if (lastSlashIndex === -1) {
      return '';
    }

    return cleanPath.substring(0, lastSlashIndex);
  }

  getFolderName(fullBlobPath: string = ''): string {
    const cleanPath = fullBlobPath.replace(/\/$/, '');
    const parts = cleanPath.split('/');
    return parts[parts.length - 1] || '';
  }

  searchKyePress(keyword: string): void {
    if (this.isNonSharePoint) {
      const searchValue = (keyword || '').trim().toLowerCase();

      if (!searchValue) {
        this.loadDmsFolder(this.currentDmsFolderPath);
        return;
      }

      const rootPath = this.getDmsRootFolderPath();
      const currentPath = this.currentDmsFolderPath || rootPath;
      const isAtRootLevel = !this.currentDmsFolderPath || this.currentDmsFolderPath === rootPath;

      if (isAtRootLevel) {
        // search across all data at the root level
        this.temptemplatedatList = this.dmsTemplateData.filter(item => {
          const itemPath = this.getCleanPath(item.fullBlobPath || '');
          if (itemPath === rootPath) {
            return false;
          }

          return ((item.name || '').toLowerCase().includes(searchValue));
        }).map(item => ({
          ...item,
          fileImageUrl: this.getImageForFile(item.name)
        }));

      } else {
        this.temptemplatedatList = this.dmsTemplateData.filter(item => {
          const itemPath = this.getCleanPath(item.fullBlobPath || '');
          if (itemPath === rootPath) {
            return false;
          }

          const itemParentPath = this.getParentPath(itemPath);
          if (itemParentPath !== currentPath) {
            return false;
          }

          return ((item.name || '').toLowerCase().includes(searchValue));
        }).map(item => ({
          ...item,
          fileImageUrl: this.getImageForFile(item.name)
        }));
      }

      return;
    }

    this.temptemplatedatList = this.withFileIcon(
      this._templatedatList.filter(item =>item.name.toLowerCase().includes(keyword.toLowerCase()))
    );
    this.breadcrumbData = [];
  }

  onSearchInputClear(): void {
    if (this.searchKeyword?.trim()) {
      return;
    }

    if (this.isNonSharePoint) {
      this.loadDmsFolder(this.currentDmsFolderPath);
      return;
    }

    this.temptemplatedatList = this.withFileIcon(this._templatedatList.filter(item => item.parentId === null));
  }

  getImageForFile(fileName: string): string {
    return this._dmsService.getImageForFile(
      fileName
    );
  }

  withFileIcon(items: any[]): any[] {
    return items.map(item => ({
      ...item,
      fileImageUrl: this.getImageForFile(item.name)
    }));
  }
}